import { SHOW_MODAL } from './types';

export const showModal = (value) => async (dispatch) => {
    dispatch({ type: SHOW_MODAL, payload: value });
};